<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control label="Tytuł:">
    <input
      [formControl]="form.controls.title"
      pInputText />
  </app-form-control>

  <app-form-control
    hint="Proszę opisać cel obrazka. Proszę pozostawić pole puste, jeśli obraz jest czysto dekoracyjny."
    label="Tekst alternatywny:">
    <textarea
      [formControl]="form.controls.alt"
      pTextarea></textarea>
  </app-form-control>

  <app-form-control label="Opis:">
    <textarea
      [formControl]="form.controls.description"
      pTextarea></textarea>
  </app-form-control>

  <div class="flex justify-end">
    <p-button
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz"
      severity="primary"
      type="submit" />
  </div>
</form>
